import {
    Hammer,
    Compass,
    Layers,
    Square,
    Trees,
    Droplets,
    MoveVertical,
    Component,
} from "lucide-react";

// Three "highlight" services shown in the 3-column grid on the homepage.
export const highlightServices = [
    {
        id: "posa-parquet",
        title: "Posa Parquet",
        description:
            "Posa professionale di parquet prefiniti e massello, con tecniche tradizionali e moderne adattate ad ogni ambiente.",
        Icon: Hammer,
    },
    {
        id: "decking-esterni",
        title: "Decking per Esterni",
        description:
            "Pavimentazioni in legno per terrazze, bordi piscina e giardini, resistenti agli agenti atmosferici della costa iblea.",
        Icon: Trees,
    },
    {
        id: "consulenza",
        title: "Consulenza e Preventivo",
        description:
            "Sopralluogo tecnico, scelta delle essenze e preventivo dettagliato senza impegno per progetti residenziali e commerciali.",
        Icon: Compass,
    },
];

// Full list of 8 services shown in the extended section.
export const allServices = [
    {
        id: "parquet-laminati",
        title: "Posa di parquet e laminati",
        description:
            "Installazione di parquet in legno nobile e di laminati di ultima generazione, con cura del dettaglio in ogni fase.",
        Icon: Layers,
    },
    {
        id: "posa-incollata",
        title: "Posa incollata",
        description:
            "Tecnica tradizionale che garantisce massima stabilità e durata, ideale per ambienti su massetto radiante.",
        Icon: Hammer,
    },
    {
        id: "posa-flottante",
        title: "Posa flottante",
        description:
            "Posa rapida e reversibile con incastro a click, perfetta per ristrutturazioni leggere e tempi di consegna brevi.",
        Icon: Component,
    },
    {
        id: "tradizionali-prefiniti",
        title: "Pavimenti tradizionali e prefiniti",
        description:
            "Selezione di essenze e formati per ogni stile, dal classico al contemporaneo, dal massello al prefinito multistrato.",
        Icon: Square,
    },
    {
        id: "pvc",
        title: "Montaggio PVC",
        description:
            "Pavimenti vinilici LVT e SPC ad alte prestazioni: silenziosi, idrorepellenti e adatti agli ambienti più sollecitati.",
        Icon: Layers,
    },
    {
        id: "decking",
        title: "Decking per esterni",
        description:
            "Decking in teak, ipe e legni termotrattati, posati su struttura tecnica per garantire ventilazione e tenuta.",
        Icon: Trees,
    },
    {
        id: "decking-olio",
        title: "Trattamento Decking con olio",
        description:
            "Manutenzione e rigenerazione di decking esistenti con oli specifici per esterni, protezione UV e salsedine.",
        Icon: Droplets,
    },
    {
        id: "pareti-scale",
        title: "Pareti e scale in legno e SPC",
        description:
            "Rivestimenti verticali, boiserie e scale su misura in legno massello, multistrato e SPC effetto legno.",
        Icon: MoveVertical,
    },
];
